import { Routes } from '@angular/router';



import { AuthUserGuard } from './core/route-guards/auth-user.guard';
import { ModuleQuizGuard } from './core/route-guards/module-quiz.guard';


import { TRAINEE_ROUTES } from './trainee/trainee.routes';
import { TraineeManagementGuard as TraineeManagementGuard } from './core/route-guards/trainee-management.guard';


export const APP_ROUTES = {
  HOME: 'home',
  QUIZ: 'quiz',
  TRAINEE: 'trainee',
  ERROR: 'error',
  COOKIES: 'cookies',
  DASHBOARD: 'dashboard',
  LOGOUT: 'logout',
};

export const routes: Routes = [
  {
    path: '',
    redirectTo: APP_ROUTES.HOME,
    pathMatch: 'full',
    title: 'Dashboard',
  },
  {
    path: APP_ROUTES.HOME,
    title: 'Dashboard',
    loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [AuthUserGuard],
  },
  {
    path: APP_ROUTES.QUIZ,
    title: ' Quiz',
    loadComponent: () => import('./quiz/quiz.component').then(m => m.QuizComponent),
    canActivate: [AuthUserGuard, ModuleQuizGuard],
  },
  {
    path: APP_ROUTES.TRAINEE,
    title: 'Trainee',
    loadComponent: () => import('./trainee/trainee.component').then(m => m.TraineeComponent),
    children: TRAINEE_ROUTES,
    canActivate: [AuthUserGuard, TraineeManagementGuard],
  },
  {
    path: APP_ROUTES.LOGOUT,
    title: 'Logout',
    loadComponent: () => import('./core/logout/logout.component').then(m => m.LogoutComponent),
  },
  {
    path: APP_ROUTES.ERROR,
    title: 'Error',
    loadComponent: () => import('./core/error-handler/error.component').then(m => m.ErrorComponent),
  },
  {
    path: APP_ROUTES.COOKIES,
    title: 'Cookies',
    loadComponent: () => import('./core/cookies/cookies.component').then(m => m.CookiesComponent),
    canActivate: [AuthUserGuard],
  },
];
